module.exports = __webpack_public_path__ + "media/src/images/partners/stifterverband-bd6b9977b831c80f6dc0110f12ff38b5.jpg";